import { Flex } from '@chakra-ui/react'
import React from 'react'
import { useNavigate, useRouteError } from 'react-router'
import styled from 'styled-components'
import noResultsIcon from '~/assets/icons/icon-no-results.svg'
import { FontStyle, Text } from '~/components/core'
import { ImageIcon } from '~/components/ImageIcon'
import { MangoButton } from '~/components/shared/MangoButton'
import { light } from '~/constants/theme'
import { useCurrentRootPath } from '~/hooks/useRouting'

const NotFoundNoticeWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2rem;
  user-select: none;
  background-color: ${light.gray200};
`

const ImageWrapper = styled.div`
  margin-bottom: 26px;
`

const NotFoundContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const NotFoundTextWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 62px;
  width: 375px;
`
const PANEL_ANIMATION_TIME_SECONDS = 0.3
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: auto;
  margin-top: 16px;
`
export interface NotFoundErrorOptions {
  cause: {
    status: number
    statusText: string
  }
}
export const throwNotFoundError = (
  message: string,
  options: NotFoundErrorOptions,
) => {
  throw new Error(message, options)
}

export const ResourceErrorBoundary = () => {
  const currentRoot = useCurrentRootPath()
  const navigate = useNavigate()
  const error = useRouteError() as Error & { cause?: { status: number } }
  let errorMessage = 'An unexpected error occurred.'
  let errorStatus = 404
  if (error && typeof error === 'object') {
    if (error.message) {
      errorMessage = error.message
    }
    if (error?.cause?.status) {
      errorStatus = error.cause.status
    }
  }
  const message =
    errorMessage ||
    'Oops this record has either been deleted or does not exist. If you need help, please contact support.'
  return (
    <Flex
      position={'inherit'}
      right="0rem"
      height="full"
      transition={`width, ${PANEL_ANIMATION_TIME_SECONDS}s`}
      borderLeft="2px solid"
      borderLeftColor="gray.400"
    >
      <NotFoundNoticeWrapper>
        <NotFoundContentWrapper>
          <ImageWrapper>
            {/* TODO: Add a custom icon for the not found notice and create other error types to throw */}
            {errorStatus === 404 ? (
              <ImageIcon
                absoluteIconPath={noResultsIcon}
                height={56}
                width={56}
              />
            ) : (
              <ImageIcon
                absoluteIconPath={noResultsIcon}
                height={56}
                width={56}
              />
            )}
          </ImageWrapper>
          <NotFoundTextWrapper>
            <Text color={light.dark900} size={FontStyle.Normal} align="center">
              {message}
            </Text>
          </NotFoundTextWrapper>
          <ButtonWrapper>
            <MangoButton
              onClick={() =>
                navigate(currentRoot, {
                  replace: true,
                })
              }
            >
              Take me back
            </MangoButton>
          </ButtonWrapper>
        </NotFoundContentWrapper>
      </NotFoundNoticeWrapper>
    </Flex>
  )
}
